import t from '../../translate'
import Field from "../../components/Field";
import React from 'react'
import CountrySelectField from './CountrySelectField'

export default function Payment ({ countries }) {
  return <>
    <p>{t('data.payment.type.label')}*</p>
    <div className={'form-row'}>
      <div className={'form-col'}>
        <div className="radio-inline">
          <div className="form-radio">
            <Field
              id={'data.payment.type.sum'}
              name="data.payment.type"
              type="radio"
              value={'sum'}
            />
            <label htmlFor={'data.payment.type.sum'}
                   className="form-radio-label">
              {t('data.payment.type.sum.label')} {' '}
              <span className="info-button" data-balloon-length="large"
                aria-label={t('data.payment.type.sum.tooltip')}
                data-balloon-pos="up">i</span>
            </label>
          </div>
          <div className="form-radio">
            <Field
              id={'data.payment.type.rates'}
              name="data.payment.type"
              type="radio"
              value={'rates'}
            />
            <label htmlFor={'data.payment.type.rates'}
                   className="form-radio-label">
              {t('data.payment.type.rates.label')} {' '}
              <span className="info-button" data-balloon-length="large"
                aria-label={t('data.payment.type.rates.tooltip')}
                data-balloon-pos="up">i</span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div className={'form-row'}>
      <div className="form-checkbox">
        <Field
          id={`data.payment.discount`}
          type="checkbox"
          name={`data.payment.discount`}
        />
        <label htmlFor={`data.payment.discount`}>
          {t('data.payment.discount')}
        </label>
      </div>
    </div>

    <h4>{t('data.payment.address.title')}</h4>
    <label htmlFor={'data.payment.address.company'}>{t(
      'data.payment.address.company')}</label>
    <Field
      id={'data.payment.address.company'}
      name={'data.payment.address.company'}
      type={'text'}/>
    <label htmlFor={'data.payment.address.department'}>{t(
      'data.payment.address.department')}</label>
    <Field
      id={'data.payment.address.department'}
      name={'data.payment.address.department'}
      type={'text'}/>
    <div className={'form-row'}>
      <div className="big-field">
        <label htmlFor={'data.payment.address.street'}>{t(
          'data.payment.address.street')}</label>
        <Field
          id={'data.payment.address.street'}
          name={'data.payment.address.street'}
          type={'text'}/>
      </div>
      <div className="middle-field">
        <label htmlFor={'data.payment.address.houseNumber'}>{t(
          'data.payment.address.houseNumber')}</label>
        <Field
          id={'data.payment.address.houseNumber'}
          name={'data.payment.address.houseNumber'}
          type={'text'}/>
      </div>
    </div>
    <div className={'form-row'}>
      <div className="middle-field">
        <label htmlFor={'data.payment.address.postalCode'}>{t(
          'data.payment.address.postalCode')}</label>
        <Field
          id={'data.payment.address.postalCode'}
          name={'data.payment.address.postalCode'}
          type={'text'}/>
      </div>
      <div className="big-field">
        <label htmlFor={'data.payment.address.city'}>{t(
          'data.payment.address.city')}</label>
        <Field
          id={'data.payment.address.city'}
          name={'data.payment.address.city'}
          type={'text'}/>
      </div>
    </div>
    <div className="form-row">
      <div className="form-col">
        <label htmlFor={'data.payment.address.country'}>{t(
          'data.payment.address.country')}</label>
        <CountrySelectField id={'data.payment.address.country'}
                            name={'data.payment.address.country'}
                            countries={countries}/>
      </div>
      <div className="form-col">
        <label htmlFor={'data.payment.address.email'}>{t(
          'data.payment.address.email')}</label>
        <Field
          id={'data.payment.address.email'}
          name={'data.payment.address.email'}
          type={'text'}/>
      </div>
    </div>
  </>
}